import React from "react";

// Screen 7 — Development (formerly "Resources"). Internal reference docs.
// Ultimately gated to users with development/admin credentials — currently
// open to all while auth is not wired up.
export default function DevelopmentScreen() {
  const links = [
    { name: "How the Engine Calculates", desc: "The 8-stage math, verbatim.", tag: "Engine spec" },
    { name: "Database Schema (Rev 7)", desc: "Every table, every column.", tag: "Data model" },
    { name: "User Identity Management", desc: "Roles, scopes, memberships, RLS.", tag: "Auth" },
    { name: "Color Palette", desc: "Official uReserve colors and usage.", tag: "Brand" },
    { name: "Screen Reference PDF", desc: "Original polished screen designs.", tag: "Design" },
  ];
  return (
    <div className="flex-1 overflow-auto" data-testid="screen-development">
      <div className="grid grid-cols-2 gap-3">
        <div className="panel-compact">
          <div className="section-title-sm">Reference Documents</div>
          <ul className="mt-2 space-y-1.5">
            {links.map((l, i) => (
              <li key={i} className="flex items-baseline gap-2 text-[12px]">
                <span className="text-[9px] tracking-wider uppercase text-slate border border-rule px-1.5 py-0.5">
                  {l.tag}
                </span>
                <span className="text-ink font-semibold">{l.name}</span>
                <span className="text-slate">— {l.desc}</span>
              </li>
            ))}
          </ul>
          <div className="mt-3 text-[11px] text-slate">
            Uploaded by Pixel Dave. Live copies are the source of truth for every calculation in this app.
          </div>
        </div>
        <div className="panel-compact">
          <div className="section-title-sm">Getting the numbers to match</div>
          <ol className="mt-2 space-y-1 text-[12px] text-ink list-decimal list-inside">
            <li>Every dollar figure on the Dashboard reconciles to the engine doc §16 worked example, to the cent.</li>
            <li>
              The Lakes Association matches the four §13 regression anchors: Full Funding{" "}
              <span className="font-mono tabular-nums">$5,619,101</span>, Contribution{" "}
              <span className="font-mono tabular-nums">$92,300</span>, PMPM{" "}
              <span className="font-mono tabular-nums">$384.58</span>, 30-yr Ending{" "}
              <span className="font-mono tabular-nums">$2,081,785</span>.
            </li>
            <li>
              Dev-mode anchors (append <span className="font-mono">?dev=1</span> to the URL) show a green ✓ next to each KPI when the current calc matches the reference.
            </li>
            <li>Changing any Scenario Variable auto-recalculates in ~350 ms. The Undo button reverts to the stored baseline.</li>
          </ol>
        </div>
        <div className="panel-compact col-span-2">
          <div className="section-title-sm">What&apos;s next</div>
          <ul className="mt-2 text-[12px] text-ink space-y-1 list-disc list-inside">
            <li>Save-As scenarios, Scenario History modal, per-element overrides (elastic what-ifs)</li>
            <li>Multi-tenant auth (Supabase Auth + RLS per your User Identity Management Guide)</li>
            <li>PDF export matching your original screen designs</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
